(() => {
  const loader =
    document.currentScript || document.querySelector("script[data-size-guide-script]");
  const src = loader?.dataset.sizeGuideScript;
  let readyPromise;
  let pendingOpener = null;

  const isReady = () => window.kpProductSizeGuideReady === true;

  const getSizeGuideModal = (target) => {
    const opener = target.closest("modal-opener[data-modal]");
    if (!opener) return null;

    const modalSelector = opener.dataset.modal;
    const modal = modalSelector ? document.querySelector(modalSelector) : null;
    if (
      !modal ||
      (!modal.hasAttribute("data-size-guide-handle") &&
        !modal.hasAttribute("data-size-guide-metafield-id"))
    ) {
      return null;
    }

    return { opener, modal };
  };

  const load = () => {
    if (!src || isReady()) return Promise.resolve();
    if (readyPromise) return readyPromise;

    readyPromise = new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts).find(
        (script) => script.src === src,
      );

      if (existing) {
        if (isReady() || existing.dataset.loaderReady === "true") {
          resolve();
          return;
        }

        existing.addEventListener(
          "load",
          () => {
            existing.dataset.loaderReady = "true";
            resolve();
          },
          { once: true },
        );
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.addEventListener(
        "load",
        () => {
          script.dataset.loaderReady = "true";
          resolve();
        },
        { once: true },
      );
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    })
      .then(() => {
        if (!isReady()) {
          throw new Error("Size guide script loaded without initializing.");
        }
      })
      .catch((error) => {
        readyPromise = null;
        throw error;
      });

    return readyPromise;
  };

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (getSizeGuideModal(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    (event) => {
      const target = getSizeGuideModal(event.target);
      if (!target || target.modal.dataset.sizeGuidePatched === "true") return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingOpener) return;
      pendingOpener = target.opener;

      load()
        .then(() => {
          pendingOpener = null;
          if (
            target.opener.isConnected &&
            target.modal.dataset.sizeGuidePatched === "true"
          ) {
            target.opener.querySelector("button")?.click();
          }
        })
        .catch(() => {
          pendingOpener = null;
        });
    },
    true,
  );
})();
